import React from "react";

const Support = () => {
  return (
    <>
      <div className="">
        <div className="pt-5 pb-2 text-center text-white">
          <h1 className="services-text">SUPPORT</h1>
          <p className="packages-paragraph">
            Need help, facing a problem or anything else? Our support team and
            community <br /> is always here to assist with all your Flash USDT
            needs.
          </p>
        </div>
        <div className="card-support card-support1">
          <div className="row">
            <div
              className="col"
              style={{
                marginLeft: "-100px",
              }}
            >
              <div className="card"></div>
            </div>
            <div className="col">
              <div className="card card-text-grouping">
                <div className="supporting left support1">
                  <div className="card-content">
                    <h2>CONTACT US</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card card-text-grouping">
                <div className="supporting right support2">
                  <div className="card-content">
                    <h2>JOIN OUR COMMUNITY</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card card-text-grouping">
                <div className="supporting right support3">
                  <div className="card-content">
                    <h2>REPORT AN ISSUE</h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col"
              style={{
                marginRight: "-100px",
              }}
            >
              <div className="card"></div>
            </div>
          </div>
        </div>
        <div className="card-support card-support2">
          <div className="row">
            <div
              className="col"
              style={{
                marginLeft: "-100px",
              }}
            >
              <div className="card"></div>
            </div>
            <div className="col">
              <div className="card card-text-grouping">
                <div className="supporting left support1">
                  <div className="card-content">
                    <h2>CONTACT US</h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col"
              style={{
                marginRight: "-100px",
              }}
            >
              <div className="card"></div>
            </div>
          </div>
          <div className="row">
            <div
              className="col"
              style={{
                marginLeft: "-100px",
              }}
            >
              <div className="card"></div>
            </div>
            <div className="col">
              <div className="card card-text-grouping">
                <div className="supporting right support2">
                  <div className="card-content">
                    <h2>JOIN OUR COMMUNITY</h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col"
              style={{
                marginRight: "-100px",
              }}
            >
              <div className="card"></div>
            </div>
          </div>
          <div className="row">
            <div
              className="col"
              style={{
                marginLeft: "-100px",
              }}
            >
              <div className="card"></div>
            </div>
            <div className="col">
              <div className="card card-text-grouping">
                <div className="supporting right support3">
                  <div className="card-content">
                    <h2>REPORT AN ISSUE</h2>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col"
              style={{
                marginRight: "-100px",
              }}
            >
              <div className="card"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
